import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { SingleField } from '@components/text-editors/addons/single-field';
import { NodeStyledFieldMappingTextEditor } from '@components/text-editors/field-mapping-text-editor';
import { useScopedTranslate } from '@locale/translate';

import { DatePlaceholder, tag, transformInput } from './extensions';

export type FieldMappingDatePickerProps = BaseFieldMappingFieldProps & FieldMappingData;

export const FieldMappingDatePicker = ({
  defaultValue,
  onChange,
  ...rest
}: FieldMappingDatePickerProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <NodeStyledFieldMappingTextEditor
      extensions={[DatePlaceholder, SingleField]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag)[0])}
      defaultValue={defaultValue?.value ? transformInput([defaultValue]) : undefined}
      placeholder={t('placeholder')}
      fieldType="date"
      disabled
      shouldShowFieldMappingOnFocus
      {...rest}
    />
  );
};

const locale = {
  en: {
    fieldMap: 'Field map',
    fieldMapDescription: 'Receive value from a field in journey',
    dateLabel: 'Date',
    placeholder: 'Select or add',
    selectDate: 'Select date',
    manuallySelectDate: 'Manually select the date',
    add: 'Add',
  },
};
